import { darken, OPA_20 } from '../themeUtils.js';

export function checkbox(ctx) {
    return {
        styles: {
            // border_width: 0 removed — identical to schema default (REDUNDANT no-op).
            main:   { text_color: ctx.TEXT, text_font: 32 },
            bullet: {
                bg_color: ctx.COLOR_BG, border_color: ctx.primary, border_width: 2,  // cb_bullet bg = COLOR_BTN light = #ffffff; border = primary color
                states: {
                    checked: { bg_color: ctx.accent, border_color: ctx.accent },
                    pressed: { bg_color: darken(ctx.COLOR_BG, OPA_20) },
                },
            },
        },
    };
}
